export default class extends HTMLElement {
  connectedCallback () {
    this.button = this.querySelector('button')
    this.menu = this.querySelector('[data-dropdown-menu]')

    if (!this.button || !this.menu) return

    this.button.addEventListener('click', (e) => {
      e.stopPropagation()
      this.menu.classList.toggle('hidden')
    })

    // Close when clicking an item inside the menu (defer slightly to let link navigation trigger)
    this.menu.addEventListener('click', (e) => {
      if (e.target.closest('a, button')) {
        setTimeout(() => {
          this.menu.classList.add('hidden')
        }, 10)
      }
    })

    // Close when clicking outside
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) {
        this.menu.classList.add('hidden')
      }
    })
  }
}
